import { slot, Slot } from "ts-event-bus";
import Geolocation from 'ol/Geolocation';

const TrailwiseEvents = {
    trackingStart: slot<string>(),
    trackingEnd: slot<string>(),
    trackingGeolocationChange: slot<Geolocation>()
};

export default TrailwiseEvents;